<template>
    <img
        :src="avatarUrl"
        alt=""
    >
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'AvatarImage',
    props: {
        url: {
            type: String,
        },
    },
    computed: {
        ...mapState(['user']),
        avatarUrl() {
            return this.user.avatar !== '' ? this.user.avatar : '/images/frontend/default-avatar.png';
        },
    },
};
</script>
